module.exports = __webpack_public_path__ + "img/btn_menu.93367f53.svg";